import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import { AppEntities } from "src/config/entities";
import { BankOpeningBalancesDto } from "../dtos/BankOpeningBalancesDto";
import { BankOpeningBalancesModel } from "../models/BankOpeningBalancesModel";
import { BankOpeningBalancesService } from "src/services/documents/BankOpeningBalancesService";
import { BankOpeningBalancesLineDto } from "../dtos/BankOpeningBalancesLineDto";


interface IProps {
    documentId?: string;
}

export const useFetchBankOpeningBalances = ({documentId}: IProps) => {
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);
    const [documentDto, setDocumentDto] = useState<BankOpeningBalancesDto | null>(null);
    const [documentModel, setDocumentModel] = useState<BankOpeningBalancesModel | null>(null);
    const dataService = AppEntities.BankOpeningBalances.getDataService() as BankOpeningBalancesService;

    const postDocument = async () => {
        if (!documentId) return;
        await dataService.PostDocument(documentId);
        toast.success("Document posted successfully");
    }

    const cancelDocument = async () => {
        if (!documentId) return;
        await dataService.CancelDocument(documentId);
        toast.success("Document canceled successfully");
    }
    
    const updateDocument = async (documentModel: BankOpeningBalancesModel) => {
        if(!documentId) return;
        console.log(documentModel)
        const requestDto: BankOpeningBalancesDto = {...documentModel};
        const responseDto = await dataService.Update(requestDto);
        setDocumentDto(responseDto);
    }

  
    const fetchDocument = async () => {
        try {
            setIsDocumentLoading(true);

            let responseDto: BankOpeningBalancesDto | null = null;
            let responseLines:BankOpeningBalancesLineDto[]=[] 
            if (!documentId) {
                responseDto = await dataService.Create({
                    documentDate: new Date(),
                });
                setDocumentDto(responseDto);
            } else {
                responseDto = await dataService.Get(documentId);
                setDocumentDto(responseDto);
            }
            
            if (!responseDto) return;
            
            const newModel: BankOpeningBalancesModel = {
                ...responseDto,
                lines: responseLines
            };
            setDocumentModel(newModel);
        } catch (e) {
            console.log(e);
        } finally {
            setIsDocumentLoading(false);
        }
    }

    useEffect(() => {
        fetchDocument();
    }, [documentId]);

    return {
        isDocumentLoading,
        documentDto,
        documentModel,
        postDocument,
        cancelDocument,
        updateDocument
    }
}
